import { render, staticRenderFns } from "./DashboardCountersWidget.vue?vue&type=template&id=966cb06a&scoped=true"
import script from "./DashboardCountersWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardCountersWidget.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DashboardCountersWidget.vue?vue&type=style&index=0&id=966cb06a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966cb06a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('966cb06a')) {
      api.createRecord('966cb06a', component.options)
    } else {
      api.reload('966cb06a', component.options)
    }
    module.hot.accept("./DashboardCountersWidget.vue?vue&type=template&id=966cb06a&scoped=true", function () {
      api.rerender('966cb06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/DashboardWidgets/counters/DashboardCountersWidget.vue"
export default component.exports